import React, { FC } from 'react';
import { useTranslation } from 'react-i18next';
import { ProductCard, ProductCardProps } from '@components/molecules/ProductCard';
import { TypographyTagVariants } from '@components/atoms/Typography';
import { SectionHeader } from '@components/molecules/SectionHeader';
import { Container } from '@components/atoms/Container';

export interface ProductsInBasketProps {
    products: ProductCardProps[];
}

export const ProductsInBasket: FC<ProductsInBasketProps> = ({ products }) => {
    const { t } = useTranslation();

    const translations = {
        title: t('basket-detail-component.products-in-basket.title'),
    };

    return (
        <Container>
            <>
                <SectionHeader title={{ text: translations.title }} />

                {/* list of products */}
                <div className="row row-gap-4 pt-2">
                    {products.map((product, index) => (
                        <div key={`product-${index}`} className="col-6 col-md-4 col-xl-3">
                            <ProductCard {...product} titleTagVariant={TypographyTagVariants.h3} />
                        </div>
                    ))}
                </div>
            </>
        </Container>
    );
};
